module.exports = __webpack_public_path__ + "img/click.69faf3b2.svg";